// extracted by mini-css-extract-plugin
export default {"input":"InputMessage_input__AcQKv","message":"InputMessage_message__SMOxr"};